

































































import Vue from 'vue'
import AddAnonymizationConfigDialog from '~/components/anonymization-config/AddAnonymizationConfigDialog.vue'
import ImportAnonymizationConfigDialog from '~/components/anonymization-config/ImportAnonymizationConfigDialog.vue'
import { AnonymizationConfig } from '@qurit/anonymizer'
import { Role } from '../../../shared/Role'
import { sortAlphabetically, filterList } from '../../helper/Utilities'
export default Vue.extend({
  components: {
    AddAnonymizationConfigDialog,
    ImportAnonymizationConfigDialog,
  },
  data: () => ({
    anonymizationConfigs: [] as AnonymizationConfig[],
    Role,
    search: '',
  }),
  created() {
    this.loadAnonymizationConfigs()
  },
  computed: {
    filteredAnonymizationConfigs(): AnonymizationConfig[] {
      return sortAlphabetically(
        filterList(this.anonymizationConfigs, this.search),
        'name'
      )
    },
  },
  methods: {
    async loadAnonymizationConfigs() {
      let res = await this.$axios.get(`anonymization-config/`)
      this.anonymizationConfigs = res.data
    },

    handleEditConfig(id: string) {
      this.$router.push(`anonymization/${id}`)
    },
  },
})
